import { VO_LIST_DEAL_PIPE_LINE } from './getVOList';

export const dealPipeLineApi = {
  fetchListWithSummary: VO_LIST_DEAL_PIPE_LINE,
};
